import React, { Component } from "react";
import Skeleton from "@material-ui/lab/Skeleton";

import { publicImageUrl } from "../../../../Config/publicImageUrl";

class LoginSchoolDetails extends Component {
  render() {
    const { schoolDetails } = this.props;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {schoolDetails.schoolLogo ? (
          <img
            src={`${publicImageUrl}/${schoolDetails.schoolLogo}`}
            alt="School_Logo"
            style={{ width: 100, height: 100 }}
          />
        ) : (
          <Skeleton vairant="circle" style={{ width: 50, height: 50 }} />
        )}

        {schoolDetails._id ? (
          <div style={{ textAlign: "center" }}>
            <div style={{ fontSize: 22, fontWeight: "bold" }}>
              {schoolDetails.schoolName}
            </div>
            <div>{schoolDetails.address}</div>
            <div>
              {schoolDetails.landLineNumber}, {schoolDetails.mobileNumber},
              {schoolDetails.email}
            </div>
          </div>
        ) : (
          <Skeleton variant="rect" style={{ width: 300, height: 40 }} />
        )}
      </div>
    );
  }
}

export default LoginSchoolDetails;
